import {
  type Comment as CommentType,
  type EntitiesToCreateComment,
} from '@entities/common/Comments/comments';
import cn from 'classnames';
import { memo, useMemo } from 'react';
import { Link } from 'react-router-dom';
import { CommentDropMenu } from '@widgets/shared/Comments/CommentDropMenu/index.tsx';
import { Like } from '@shared/assets/index.ts';
import { getInitialM } from '@shared/helpers/index.ts';
import { useUser } from '@shared/hooks/index.ts';
import * as st from './styles.module.scss';

export type CommentPT = CommentType &
  EntitiesToCreateComment & {
    isContentAuthor: boolean;
  };
const fakeHandler = () => console.log('fake handler');
// const answer = false;
export const Comment = memo(
  ({
    isContentAuthor,
    user,
    answers,
    text,
    user_liked,
    updated_at,
    id,
    program,
    article,
  }: CommentPT) => {
    const { user: currentUserInApp } = useUser();

    const commentDate = useMemo(() => {
      const date = new Date(updated_at);
      return `${date.getDay()}.${date.getMonth()}.${String(date.getFullYear()).slice(2)}`;
    }, [updated_at]);

    const commentAuthorName = useMemo(
      () => getInitialM(user.first_name, user.middle_name, user.last_name),
      [user]
    );

    const answer = useMemo(() => answers[answers.length - 1], [answers]);

    return (
      <article>
        <section className={st.head}>
          <img className={st.avatar} src={user.photo} alt={`CommentAvatar${user.photo}`} />
          <span>{commentAuthorName}</span>
          <span>{commentDate}</span>
          {user_liked && <Like className={st.like} />}
          <CommentDropMenu
            program={program}
            article={article}
            commentId={String(id)}
            isContentAuthor={isContentAuthor}
            isAuthor={currentUserInApp?.id === user.id}
            onWatchProfile={fakeHandler}
            canWatchProfile={isContentAuthor}
          />
        </section>
        <p className={cn(st.content, !answer && isContentAuthor && st.marginBottom)}>{text}</p>
        {answer ? (
          <section className={st.answer}>
            <div className={st.line}></div>
            <section className={st.answerInnerWrapper}>
              <div className={st.answerLabelWithDropdown}>
                <p className={st.answerLabel}>Ответ автора</p>
                {isContentAuthor && (
                  <CommentDropMenu
                    program={program}
                    article={article}
                    className={st.dropdownNearAnswerLabel}
                    commentId={String(answer.id)}
                    isAuthor={currentUserInApp?.id === answer.user.id}
                    isContentAuthor={isContentAuthor}
                    onWatchProfile={fakeHandler}
                  />
                )}
              </div>
              <p className={cn(st.content, st.answerContent)}>{answer.text}</p>
            </section>
          </section>
        ) : isContentAuthor ? (
          <Link
            to={`${id}`}
            state={{ pageTitle: 'Ответ', type: 'answer', program, article }}
            className={st.link}
          >
            Ответить
          </Link>
        ) : undefined}
      </article>
    );
  }
);
